// extracted by mini-css-extract-plugin
module.exports = {"Error404":"Error404_Error404__yMZhM","Link":"Error404_Link__3h1B4"};